(function(dW, dD, dHtml) {

    dW.ZP_VC_ACCORDION = [];

    dW.addEventListener(dW.ZP_DEFAULT.ZP_EVENT_ELEMENTS_INIT, init);

    function init()  {

        dW.removeEventListener(dW.ZP_DEFAULT.ZP_EVENT_ELEMENTS_INIT, init);

        let dElements = document.querySelectorAll('.zp_accordion');

        for(let i = 0; i < dElements.length; i++) {

            dW.ZP_VC_ACCORDION.push(new Accordion(dElements[i]));

        }

    }

    class Accordion {

        constructor(root) {

            this.dRoot = root;

            this.dElements = {
				elements : this.dRoot.querySelectorAll(".zp_accordion_element"),
			};

            this.elements = [];

            this.id = this.dRoot.getAttribute("id");

			this.init();
        }

        init() {

            if(this.dElements.elements.length > 0) {

                let i = 0;

                while(i < this.dElements.elements.length) {

                	let dElement = this.dElements.elements[i];
                	let element = new AccordionElement(dElement);
                	element.dElements.header.setAttribute("data-parent", "#" + this.id);
                	element.init();
                    this.elements.push(element);

                    i = i + 1;
                }

            }

        }

    }

    class AccordionElement {

        constructor(root) {

            this.dRoot = root;

            this.dElements = {
				header : this.dRoot.querySelectorAll(".collapse-header")[0],
				content : this.dRoot.querySelectorAll(".collapse-content")[0]
			};

            this.isOpen = false;

        }
        
        init() {

        	this.eventHeaderClickHandler = this.onHeaderClick.bind(this);

        	this.collapse = new Collapse(this.dElements.header);

			this.addListener();

		}

		addListener() {

        	this.dElements.header.addEventListener("click", this.eventHeaderClickHandler);

		}

		removeListener() {

            this.dElements.header.removeEventListener("click", this.eventHeaderClickHandler);

		}

		onHeaderClick(e) {

        	if(this.isOpen) {

        		this.closeElement();

			} else {

        		this.openElement();

			}

		}

		openElement() {

        	this.dRoot.classList.add("open");
        	this.isOpen = true;

		}


		closeElement() {

            this.dRoot.classList.remove("open");
            this.isOpen = false;

		}

	}

}(window, document, document.getElementsByTagName('html')[0]));